import { useStoreAssetsV2Query } from '@/graphql/queries/storeAssetsV2.generated';
import { StoreAssetV2FragmentFragment } from '@/graphql/fragments/storeAssetV2.generated';
import { DEFAULT_PAGE_SIZE } from './utils';
import { useContext } from 'react';
import {
  IsVytalEmployee,
  ViewerContext,
} from '@/providers/ViewerContextProvider';

export type StoreAsset = StoreAssetV2FragmentFragment;

interface UseStoreAssetsOptions {
  storeId?: string;
  page: number;
  pageSize?: number;
  skip?: boolean;
  hideDeleted?: boolean;
}

export function useStoreAssets({
  storeId,
  page,
  pageSize = DEFAULT_PAGE_SIZE,
  skip = false,
  hideDeleted = false,
}: UseStoreAssetsOptions) {
  const viewer = useContext(ViewerContext);
  const isVytalEmployee = IsVytalEmployee(viewer);

  const { data, previousData, loading, error, refetch } = useStoreAssetsV2Query(
    {
      variables: {
        filter: {
          store_id: storeId,
          include_deleted: !hideDeleted && isVytalEmployee,
        },
        skip: (page - 1) * pageSize,
        take: pageSize,
      },
      skip: skip || !storeId,
      fetchPolicy: 'no-cache',
    },
  );

  const effective = data ?? previousData;
  const items = effective?.storeAssetsV2?.items ?? [];
  const total = effective?.storeAssetsV2?.total ?? 0;
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const initialLoading = loading && !effective;

  return {
    items,
    total,
    totalPages,
    loading,
    initialLoading,
    error,
    refetch,
  };
}
